export default {"src":"/_next/static/media/star_64.df1bda22.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};